import { render, staticRenderFns } from "./CheckoutPerson.vue?vue&type=template&id=fba3cba2"
import script from "./CheckoutPerson.vue?vue&type=script&lang=js"
export * from "./CheckoutPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports